module.exports = __webpack_public_path__ + "static/img/6.01a6d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.jpg
// module id = k9Qt
// module chunks = 1